var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polyline, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1e53;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.05,30.73a4.3,4.3,0,0,1,4.37-4.23h0a4.3,4.3,0,0,1,4.37,4.23h0V35.9H65.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.76,31.2A4.37,4.37,0,1,0,79.13,27a4.3,4.3,0,0,0-4.37,4.23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.5,40.13a4.3,4.3,0,0,1,4.37-4.23h0a4.3,4.3,0,0,1,4.37,4.23V45.3H16.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.21,40.6a4.37,4.37,0,1,0,4.37-4.23,4.3,4.3,0,0,0-4.37,4.23h0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.63,40.6A4.37,4.37,0,1,0,50,36.37a4.3,4.3,0,0,0-4.37,4.23h0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,40.13a4.3,4.3,0,0,1,4.37-4.23h0a4.3,4.3,0,0,1,4.37,4.23V45.3H55.34Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.05,35.9h8.74v5.17a4.3,4.3,0,0,1-4.37,4.23h0a4.3,4.3,0,0,1-4.37-4.23h0Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16.5 45.3 25.24 45.3 25.24 54.7 16.5 54.7 16.5 45.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.92,50a4.37,4.37,0,1,0,4.37-4.23A4.3,4.3,0,0,0,35.92,50"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,45.3h8.74v5.17a4.3,4.3,0,0,1-4.37,4.23h0a4.3,4.3,0,0,1-4.37-4.23Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.76,50a4.37,4.37,0,1,0,4.37-4.23A4.3,4.3,0,0,0,74.76,50"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.5,54.7h8.74v5.17a4.3,4.3,0,0,1-4.37,4.23h0a4.3,4.3,0,0,1-4.37-4.23h0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.21,58.93a4.3,4.3,0,0,1,4.37-4.23h0A4.3,4.3,0,0,1,35,58.93h0V64.1H26.21Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.21,64.1H35v5.17a4.3,4.3,0,0,1-4.37,4.23h0a4.3,4.3,0,0,1-4.37-4.23h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.92,68.8a4.37,4.37,0,1,0,4.37-4.23,4.3,4.3,0,0,0-4.37,4.23h0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.63,68.8A4.37,4.37,0,1,0,50,64.57a4.3,4.3,0,0,0-4.37,4.23h0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,68.8a4.37,4.37,0,1,0,4.37-4.23,4.3,4.3,0,0,0-4.37,4.23h0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.76,68.8a4.37,4.37,0,1,0,4.37-4.23,4.3,4.3,0,0,0-4.37,4.23h0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.5e6523418ec0a5617839afa9a1601ed1.svg";
export { ForwardRef as ReactComponent };